WB.Utility = WB.Utility || {};
WB.Utility.Events = function() {
    
    function Events() {
        this.events = {};
    }

    Events.prototype.fire = function(eventStr, targetFn) {
        if (!this.events[eventStr]) {
            return;
        }
        this.events[eventStr].forEach(function(fn) {
            targetFn.call(this, fn);
        });
    };
    
    Events.prototype.setEvent = function(eventStr, fn) {
        this.events[eventStr] = this.events[eventStr] || [];
        this.events[eventStr].length = 0;
        this.events[eventStr].push(fn);
    };
    
    Events.prototype.on = function(eventStr, fn) {
        this.events[eventStr] = this.events[eventStr] || [];
        this.events[eventStr].push(fn);
    };

    Events.prototype.off = function(eventStr, fn) {
        if (fn) {
            var index = this.events[eventStr].indexOf(fn);
            this.events[eventStr].splice(index, 1);
        } else {
            this.events[eventStr].length = 0;
        }
    };

    return Events;
};
WB.Utility.Events.$inject = [];
WB.App.factory('Events', WB.Utility.Events);